/**
 * 当前 Site 只保存在内存中，不写入 Web Storage。
 *
 * 登录后的 /auth/me 是 Site 会话真源；AuthContext 在水合、登录、切换和登出时同步这里。
 */
let currentSitePublicId: string | null = null;

export type SiteChangeListener = (
  currentSitePublicId: string | null,
  previousSitePublicId: string | null,
) => void;

const siteChangeListeners = new Set<SiteChangeListener>();

export const getCurrentSitePublicId = (): string | null => currentSitePublicId;

export const setCurrentSitePublicId = (sitePublicId: string | null): void => {
  const normalized = sitePublicId?.trim();
  const nextSitePublicId = normalized || null;
  const previousSitePublicId = currentSitePublicId;
  if (previousSitePublicId === nextSitePublicId) {
    return;
  }

  currentSitePublicId = nextSitePublicId;
  siteChangeListeners.forEach((listener) => {
    listener(nextSitePublicId, previousSitePublicId);
  });
};

export const clearCurrentSitePublicId = (): void => {
  setCurrentSitePublicId(null);
};

export const subscribeToCurrentSiteChange = (listener: SiteChangeListener): (() => void) => {
  siteChangeListeners.add(listener);
  return () => {
    siteChangeListeners.delete(listener);
  };
};
